import React from 'react';
import PropTypes from 'prop-types';
import Offer from '../Offer';
import './OffersList.scss';

const OffersList = props => {
  if (props.items.length === 0) {
    return null;
  }
  return (
    <section className="offers-list-wrapper">
      <div className="container-guttered offers-list">
        {props.items.map((offer, key) => (
          <Offer
            description={offer.longDescription}
            key={`offer-${key}`}
            offerCtaText={props.offerCtaText}
            copiedNotificationText={props.copiedNotificationText}
            {...offer}
          />
        ))}
      </div>
    </section>
  );
};

OffersList.propTypes = {
  items: PropTypes.array.isRequired,
  offerCtaText: PropTypes.string.isRequired,
  copiedNotificationText: PropTypes.string.isRequired,
};;

export default OffersList;



// WEBPACK FOOTER //
// ./src/client/js/view/components/OffersList/OffersList.js